export function FunnelVertical({ stages }) {
  const max = Math.max(1, ...stages.map((s) => s.count));
  return (
    <div className="funnel-v">
      {stages.map((s, i) => {
        const w = 40 + (s.count / max) * 56;
        return (
          <div key={s.label} className="funnel-v__stage">
            <div className="funnel-v__bar-wrap">
              <div className="funnel-v__bar" style={{ width: `${w}%` }} />
            </div>
            <div className="funnel-v__meta">
              <span className="funnel-v__label">{s.label}</span>
              <span className="funnel-v__count">
                {s.count.toLocaleString()}
                {s.pct != null && <span className="funnel-v__pct">{s.pct}</span>}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
